import { render } from "./Payment_proposal_dashboard.vue?vue&type=template&id=53150cb5&scoped=true"
import script from "./Payment_proposal_dashboard.vue?vue&type=script&lang=js"
export * from "./Payment_proposal_dashboard.vue?vue&type=script&lang=js"

import "./Payment_proposal_dashboard.vue?vue&type=style&index=0&id=53150cb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53150cb5"]])

export default __exports__